import { get } from 'lodash';
import { IndexedObject } from 'types';
import { initialState } from './apiStatus.initialState';
import { ApiStatusState } from './apiStatus.types';

export interface Action {
  type: string;
  payload: string | number | Array<any> | object;
}

const apiStatusReducer = (
  state: ApiStatusState = initialState,
  action: Action
): ApiStatusState => {
  const { type } = action;
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

  // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    loading: {
      ...state.loading,
      [requestName]: requestState === 'REQUEST',
    },
    errors: {
      ...state.errors,
      [requestName]:
        requestState === 'FAILURE'
          ? action.payload
            ? get(
                action.payload,
                'code',
                get(action, 'meta.responseBody.code', 'error')
              )
            : 'error'
          : '',
    },
    init: {
      ...state.init,
      [requestName]: requestState === 'SUCCESS' || state.init[requestName],
    },
  };
};

export default apiStatusReducer;
